import { Component, OnInit, Input,Output ,EventEmitter, ɵConsole} from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertasComponent } from '../../../alertas/alertas.component';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-register-subscriber',
  templateUrl: './register-subscriber.component.html',
  styleUrls: ['./register-subscriber.component.sass']
})
export class RegisterSubscriberComponent implements OnInit {
  
  public txtType;
  @Input()  viewSession;
  public  account = new FormControl('',[
    Validators.required, Validators.pattern("^[0-9]*$")
  ]);;
  private  accountType;
  private  accountSubType;

  @Output() updateView = new EventEmitter<number>();
  @Output() updateText = new EventEmitter<number>();
  @Output() updateSub = new EventEmitter<number>();
  @Output() updateAccountType = new EventEmitter<number>();
  @Output() updateAccountSubType = new EventEmitter<number>();

  constructor(private loadingScreenService :LoadingScreenService ,private services: Service,public global:GlobalService,public dialog:MatDialog) { }

  ngOnInit() {}

  getIn(event,E){
    if(event.key){
      if(event.key=="Enter"){
        this.submitForm();
      }
      else{
        this.global.validateInputKey(event);  
      }
    }
    else{
      this.global.validateInputKey(event);
    }
  }
  submitForm() {
      if (this.account.value.toString().length != 9) {
          this.global.notif("Debe ingresar un número de cuenta válido.");    
      } 
      else {
          if (this.account.value.toString().match(/[0-9]{9}/)) {
              this.loadingScreenService.startLoading();
              this.services.validateAccount(this.account.value.toString()).subscribe(data =>{
                this.loadingScreenService.stopLoading();
                if(data.hasError ==false){
                  if(data.accountType=='H'){
                    this.accountType = data.accountType;
                    this.accountSubType = data.accountSubType;
                    this.txtType = this.global.checkTypeAccount(this.accountType);
                    this.global.notif(data.errorDisplay);
                    this.updateText.emit(this.txtType);
                    this.viewSession = 2;
                    this.updateView.emit(this.viewSession);
                    this.updateText.emit(this.txtType);
                    this.updateSub.emit(this.account.value);
                    this.updateAccountType.emit(this.accountType);
                    this.updateAccountSubType.emit(this.accountSubType);
                  }
                  else{
                    this.global.notif("Solo esta permitdo el registro de cuentas Wholesale.");
                  }
              }
              else{
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                alert(data.accountType);
                if(data.accountType=='H'){
                  dialogConfig.data = {message:data.errorDisplay,messageHtml:true};
                }
                else{
                  dialogConfig.data = {message:'Solo esta permitdo el registro de cuentas Wholesale.',messageHtml:true};
                }
                const dialogRef =this.dialog.open(AlertasComponent, dialogConfig);
              }
            });
          } 
          else {
            this.global.notif("Debe ingresar un número de suscriptor válido.");
            this.loadingScreenService.stopLoading();
          }
      }
  }
}